<template>
    <div class="print-template-manager">
        <a-modal title="打印模板管理" :visible="visible" :footer="null" width="800px" @cancel="handleClose">
            <div class="print-template-modal">
                <div class="template-header">
                    <a-button type="primary" @click="handleAddTemplate">
                        <a-icon type="plus" />添加模板
                    </a-button>
                </div>
                <a-table :columns="columns" :data-source="templates" :row-key="record => record.id" :loading="loading"
                    :pagination="{
                        total: total,
                        current: page,
                        pageSize: limit,
                        onChange: handlePageChange
                    }">
                    <template slot="action" slot-scope="text, record">
                        <a-space>
                            <a @click="handlePrint(record)">打印</a>
                            <a-divider type="vertical" />
                            <a @click="handleDesign(record)">设计</a>
                            <a-divider type="vertical" />
                            <a-popconfirm title="确定要删除该模板吗？" @confirm="handleDeleteTemplate(record.id)">
                                <a>删除</a>
                            </a-popconfirm>
                        </a-space>
                    </template>
                </a-table>
            </div>
        </a-modal>

        <!-- 模板编辑弹窗 -->
        <print-template-editor :visible.sync="editorVisible" :platform="platform" :template="currentTemplate"
            @success="handleEditorSuccess" />
    </div>
</template>

<script>
import request from '@/utils/request'
import { API } from '@/config/api'
import PrintTemplateEditor from './PrintTemplateEditor.vue'

export default {
    name: 'PrintTemplateManager',
    components: {
        PrintTemplateEditor
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        platform: {
            type: String,
            required: true
        },
        userId: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            templates: [], // 打印模板列表
            loading: false,
            editorVisible: false,
            currentTemplate: {},
            page: 1,
            limit: 10,
            total: 0,
            columns: [
                {
                    title: '模板名称',
                    dataIndex: 'name',
                    key: 'name'
                },
                {
                    title: '操作',
                    key: 'action',
                    dataIndex: 'action',
                    width: '200px',
                    scopedSlots: { customRender: 'action' }
                }
            ]
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false)
            this.$emit('close')
        },
        async fetchTemplates() {
            this.loading = true
            try {
                const res = await request.post(API.PRINT_TEMPLATE_LIST, {
                    platform: this.platform,
                    page: this.page,
                    limit: this.limit
                })
                if (res.code === 1) {
                    if (Array.isArray(res.data.data)) {
                        this.templates = res.data.data.map(item => ({
                            ...item,
                            key: item.id
                        }))
                        console.log('Processed templates:', this.templates)
                    } else {
                        this.templates = []
                    }
                    this.total = res.data.total
                    this.page = res.data.current_page
                    this.limit = parseInt(res.data.per_page)
                } else {
                    this.templates = []
                    this.$message.error(res.msg || '获取模板列表失败')
                }
            } catch (error) {
                this.templates = []
                this.$message.error('获取打印模板列表失败：' + error.message)
            } finally {
                this.loading = false
            }
        },
        handlePageChange(page) {
            this.page = page
            this.fetchTemplates()
        },
        handleAddTemplate() {
            this.currentTemplate = {}
            this.editorVisible = true
        },
        async handleDeleteTemplate(id) {
            try {
                const res = await request.post(API.PRINT_TEMPLATE_DELETE, {
                    id: id
                })
                if (res.code === 1) {
                    this.$message.success('删除成功')
                    this.fetchTemplates()
                } else {
                    this.$message.error(res.msg || '删除失败')
                }
            } catch (error) {
                this.$message.error('删除失败：' + error.message)
            }
        },
        handleEditorSuccess() {
            this.fetchTemplates()
        },
        async handlePrint(record) {
            console.log('打印模板:', record)
            if (!window.electron) {
                console.error('Electron API not available')
                this.$message.error('Electron 环境未正确初始化')
                return
            }
            try {
                // 获取操作系统类型
                const executablePath = '.\\bank-flow-windows\\bank-transfer-flow.exe'
                // 构建完整的命令
                const cmdStr = `"${executablePath}" "${this.platform}" "${this.userId}" "${record.id}"`
                console.log('Executing command:', cmdStr)

                const { stdout, stderr } = await window.electron.ipcRenderer.invoke('execute-command', cmdStr)
                console.log('Command output:', stdout)
                if (stderr) {
                    console.warn('Print warning:', stderr)
                }
                this.$message.success('打印成功')
            } catch (error) {
                console.error('Print error:', error)
                this.$message.error('打印失败：' + (error.message || '未知错误'))
            }
        },
        async handleDesign(record) {
            console.log('设计模板:', record)
            if (!window.electron) {
                console.error('Electron API not available')
                this.$message.error('Electron 环境未正确初始化')
                return
            }
            try {
                const { stdout, stderr } = await window.electron.ipcRenderer.invoke('execute-command', `pwd`)
                console.log('Command output:', stdout)
                if (stderr) {
                    console.warn('Design warning:', stderr)
                }
                this.$message.success('设计器启动成功')
            } catch (error) {
                console.error('Design error:', error)
                this.$message.error('设计器启动失败：' + (error.message || '未知错误'))
            }
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.page = 1
                this.fetchTemplates()
            }
        }
    }
}
</script>

<style scoped>
.template-header {
    margin-bottom: 16px;
}
</style>